<template>
  <div class="container page" style="width: 100%; background: #fff">
    <div class="header">
      <van-nav-bar :title="$t('foorter.top32')" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#000" @click="back()" />
        </template>
      </van-nav-bar>
    </div>
    <div style="width: 100%; height: 44px; line-height: 44px; font-size: 16px">
      <div
        style="
          display: flex;
          width: 50%;
          float: left;
          margin-left: 0px;
          height: 44px;
          line-height: 44px;
        "
      >
        <div
          :class="index1 ? 'act' : ''"
          @click="toStatus(1)"
          style="
            margin: auto;
            display: flex;
            justify-content: center;
            height: 44px;
            line-height: 44px;
          "
        >
          {{ $t("foorter.top33") }}
        </div>
      </div>
      <div
        style="
          display: flex;
          width: 50%;
          float: right;
          margin-right: 0px;
          height: 44px;
          line-height: 44px;
        "
      >
        <div
          :class="index2 ? 'act' : ''"
          @click="toStatus(2)"
          style="
            margin: auto;
            display: flex;
            justify-content: center;
            height: 44px;
            line-height: 44px;
          "
        >
          {{ $t("foorter.top34") }}
        </div>
      </div>
    </div>
    <div class="content" :style="index1 ? 'display:block' : 'display:none'">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <template v-if="notice && notice.length > 0">
          <div class="listItem" v-for="(v, key) in notice" :key="key">
            <div class="listTitle">{{ v.name }}</div>
            <div class="listContent html">
              <p>{{ v.text }}<br /></p>
            </div>
            <div class="listTime">
              <div class="listTimeText">{{ v.create_time }}</div>
            </div>
          </div>
        </template>
        <van-empty v-else :description="$t('withdraw.empty_data')" />
      </van-pull-refresh>
    </div>
    <div class="content" :style="index2 ? 'display:block' : 'display:none'">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <template v-if="msg && msg.length > 0">
          <div class="listItem" v-for="(v, key) in msg" :key="key">
            <div class="listTitleRow" @click="toggleMsgExpand(key)">
              <div class="listTitleText">{{ v.name }}</div>
              <div class="expandIconWrap" @click.stop="toggleMsgExpand(key)">
                <van-icon
                  class="expandIcon"
                  :class="{ rotated: isMsgExpanded(key) }"
                  name="arrow-down"
                />
                <span v-if="isMsgUnread(v)" class="unreadBadge"></span>
              </div>
            </div>
            <div
              class="listContent html"
              :ref="'msgContent_' + key"
              :style="
                msgMaxHeight[key] ? { maxHeight: msgMaxHeight[key] } : null
              "
              :class="{ collapsed: isMsgClamped(key) }"
              @transitionend="onMsgContentTransitionEnd(key, $event)"
            >
              <p>{{ v.text }}<br /></p>
            </div>
            <div class="listTime">
              <div class="listTimeText">{{ v.create_time }}</div>
            </div>
          </div>
        </template>
        <van-empty v-else :description="$t('withdraw.empty_data')" />
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      notice: [],
      index1: true,
      index2: false,
      msg: [],
      expandedMsg: {},
      msgClamp: {},
      msgMaxHeight: {},
      loading: false,
      finished: false,
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    getNoticeList() {
      this.$http({
        method: "get",
        url: "sys_get_notice_list",
      }).then((res) => {
        console.debug("notice", res.data);
        this.notice = Array.isArray(res.data)
          ? res.data
          : Object.values(res.data || {});
      });
    },
    getMsgList() {
      this.$http({
        method: "get",
        url: "sys_get_msg_list",
      }).then((res) => {
        console.debug("msg", res.data);
        this.msg = Array.isArray(res.data)
          ? res.data
          : Object.values(res.data || {});
        // this.expandedMsg = {};
        // this.msgClamp = {};
        // this.msgMaxHeight = {};
      });
    },
    isMsgExpanded(key) {
      return !!this.expandedMsg[key];
    },
    isMsgUnread(v) {
      return v && (v.status === 0 || v.status === "0");
    },
    isMsgClamped(key) {
      // default to clamped (collapsed) until explicitly expanded
      return this.msgClamp[key] !== false;
    },
    getMsgContentEl(key) {
      const ref = this.$refs[`msgContent_${key}`];
      return Array.isArray(ref) ? ref[0] : ref;
    },
    getMsgLineHeightPx(el) {
      const p = el && el.querySelector ? el.querySelector("p") : null;
      if (!p) return 0;
      const lh = window.getComputedStyle(p).lineHeight;
      const px = parseFloat(lh);
      return Number.isFinite(px) ? Math.ceil(px) : 0;
    },
    toggleMsgExpand(key) {
      if (this.isMsgExpanded(key)) {
        this.collapseMsg(key);
      } else {
        this.expandMsg(key);
      }
    },
    expandMsg(key) {
      const el = this.getMsgContentEl(key);
      if (el) {
        // lock the current (collapsed) height so it won't jump when we remove clamp
        this.$set(this.msgMaxHeight, key, `${Math.ceil(el.offsetHeight)}px`);
      }
      this.$set(this.msgClamp, key, false);
      this.$set(this.expandedMsg, key, true);

      this.$nextTick(() => {
        const el2 = this.getMsgContentEl(key);
        if (!el2) return;
        this.$set(this.msgMaxHeight, key, `${Math.ceil(el2.scrollHeight)}px`);
      });
      if (this.isMsgUnread(this.msg[key])) {
        this.readMsg(this.msg[key].id);
      }
    },
    collapseMsg(key) {
      const el = this.getMsgContentEl(key);
      // keep unclamped during the shrinking animation to avoid "two-stage" snap
      this.$set(this.msgClamp, key, false);
      this.$set(this.expandedMsg, key, false);

      if (!el) {
        this.$set(this.msgClamp, key, true);
        return;
      }

      this.$set(this.msgMaxHeight, key, `${Math.ceil(el.scrollHeight)}px`);
      const lineHeight = this.getMsgLineHeightPx(el) || 0;
      window.requestAnimationFrame(() => {
        this.$set(
          this.msgMaxHeight,
          key,
          `${lineHeight || Math.ceil(el.offsetHeight)}px`,
        );
      });
    },
    onMsgContentTransitionEnd(key, e) {
      if (!e || e.propertyName !== "max-height") return;
      if (!this.isMsgExpanded(key)) {
        this.$set(this.msgClamp, key, true);
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
        this.getNoticeList();
      }, 500);
    },
    toStatus(id) {
      if (id == 1) {
        this.index1 = true;
        this.index2 = false;
      }
      if (id == 2) {
        this.index1 = false;
        this.index2 = true;
      }
    },
    readMsg(key) {
      this.$http({
        method: "get",
        url: "read_msg",
        data: {
          id: key,
        },
      }).then((res) => {
        console.debug("readMsg", res.data);
        this.getMsgList();
      });
    },
  },
  created() {
    this.getNoticeList();
    this.getMsgList();
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";
::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}
.act {
  color: rgb(245, 61, 135);
  border-bottom: solid #f53d87 3px;
}
.container .content {
  height: calc(100% - 20px);
  overflow: auto;
  padding-bottom: 40px;
}
.nav-bar {
  background: unset;
  color: #000;
}
::v-deep .van-nav-bar__title {
  color: #000;
}
.container .content .listItem {
  margin-bottom: 20px;
  padding: 20px 30px 0 30px;
  position: relative;
  color: #000;
  border-bottom: 1px solid #999;
  background-color: #fff;
}
.container .content .listItem .listTitleRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.container .content .listItem .listTitleText {
  font-size: 32px;
  color: #222;
  flex: 1;
  min-width: 0;
}
.container .content .listItem .expandIcon {
  color: #666;
  font-size: 32px;
  transition: transform 0.2s ease-in-out;
  transform-origin: 50% 50%;
}
.container .content .listItem .expandIcon.rotated {
  transform: rotate(180deg);
}
.container .content .listItem .expandIconWrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
}
.container .content .listItem .unreadBadge {
  position: absolute;
  top: 2px;
  right: -2px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #ee0a24;
  border: 2px solid #fff;
  box-sizing: content-box;
}
.container .content .listItem .listContent {
  // border-bottom: 2px solid #f2f2f5;
  text-indent: 2em;
  padding: 5px 0;
  color: #323233;
  font-size: 24px;
  overflow: hidden;
  max-height: 10000px;
  margin-top: 16px;
  transition: max-height 0.2s ease-in-out;
}
.container .content .listItem .listContent p {
  margin: 0;
  line-height: 1.6;
}
.container .content .listItem .listContent br {
  display: none;
}
.container .content .listItem .listContent.collapsed p {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}
.container .content .listItem .listContent.collapsed {
  max-height: 1.6em;
  margin-top: 16px;
}
.container .content .listItem .listTime {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  height: 60px;
  pointer-events: none;
}
.container .content .listItem .listTime .listTimeText {
  color: #656566;
  font-size: 30px;
}
.empty-state {
  padding: 80px 0;
  text-align: center;
  color: #999;
  font-size: 30px;
}
</style>
